import { persist, createSessionStorage, setSerialization } from '@macfja/svelte-persistent-store';
import { writable } from 'svelte/store';
import { sections, classroomSections, manageSections } from '$lib/Global';
import { customSerialization } from './serialization.js';

setSerialization(...customSerialization);

export const currentSection = writable(sections.CLASSROOM);
export const currentClassroomSection = persist(writable(null), createSessionStorage(), 'currentClassroomSection');;
export const currentClassroomSubSection = writable(classroomSections.DASHBOARD);
export const currentManageSection = writable(manageSections.ENTITIES);
export const currentManageSubSection = writable(manageSections.ENTITIES);

export const currentMarkbook = writable();

export const currentBreadcrumb = writable();

export const device = writable();

